import axios from 'axios';
import {backendHost} from '../../config';

export const getPromoById = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/promo`, {params});
};